import { RegulationDto } from "api"
import PollutionTable from "components/carModelPage/sections/specifications/PollutionTable"
import SafetyTable from "components/carModelPage/sections/specifications/SafetyTable"
import Image from "next/image"
import PopUp from "reusable/popups/PopUp"
import styled from "styled-components"

const StyledInnerContent = styled.div`
  width: 400px;
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
  table {
    width: 100%;
  }
`
const StyledImageContainer = styled.div`
  height: 100px;
  position: relative;
`

type ImageModalProps = {
  open: boolean
  onClose: () => void
  label: string
  regulation: RegulationDto
  modalType: string
}

const ImageModal = ({
  open,
  onClose,
  label,
  regulation,
  modalType,
}: ImageModalProps) => (
  <PopUp header={label} setOpen={onClose} open={open} maxWidth="md">
    <StyledInnerContent>
      <StyledImageContainer>
        <Image
          src={
            modalType === "pollution"
              ? regulation.pollutionMainImage
              : regulation.safetyMainImage
          }
          alt={"alt"}
          fill
          sizes="100vw" />
      </StyledImageContainer>
      {modalType === "pollution" && <PollutionTable data={regulation} />}
      {modalType === "safety" && <SafetyTable data={regulation} />}
    </StyledInnerContent>
  </PopUp>
)

export default ImageModal
